import * as React from "react";
import { useCallback, useImperativeHandle, useMemo, useState } from "react";
import SendNotificationBulk from "security-app/components/SecurityEvents/Alerts/AlertsModals/NotificationsModal/SendNotificationBulk";
import MenuItem from "components/bootstrap/menuitem/MenuItem";
const SendNotificationsModalInner = ({ events, fromBulk = false }, ref) => {
  const [showModal, setShowModal] = useState(false);
  const eventIds = useMemo(() => events.map((event) => event.id), [events]);
  const onClose = useCallback(() => setShowModal(false), []);
  useImperativeHandle(ref, () => ({
    toggle: () => setShowModal(true)
  }));
  return /* @__PURE__ */ React.createElement(SendNotificationBulk, { eventIds, onClose, show: showModal, fromBulk });
};
export const SendNotificationsModal = React.forwardRef(SendNotificationsModalInner);
export const SendNotificationsEventAction = ({ modalRef, onEventCallback }) => {
  const onClick = () => {
    if (typeof onEventCallback === "function") {
      onEventCallback();
    }
    return modalRef().toggle();
  };
  return /* @__PURE__ */ React.createElement(MenuItem, { onClick }, "Send Notifications");
};
